<app-custom-select [iconClass]="'text-indent-left fw-bold'" [options]="clearingCompaniesList" [(ngModel)]="localValue"
  [title]="title" (ngModelChange)="onValueChange($event)" [isDisabled]="isDisabled" [createNewText]="'Add New Clearing Company'"
  (onClickCreateNew)="createNewClearingCompany()"></app-custom-select>
